import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:flex-1 flex flex-col items-start text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              {siteInfo.tagline}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              {siteInfo.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href={siteInfo.ctaPrimary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaPrimary.href)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                {siteInfo.ctaPrimary.text}
              </a>
              <a
                href={siteInfo.ctaSecondary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaSecondary.href)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 border border-foreground-200 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {siteInfo.ctaSecondary.text}
              </a>
            </div>
          </div>

          <div className="w-full lg:flex-1">
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20video%20streaming%20platform%20interface%20displayed%20on%20a%20large%20screen%20with%20movie%20posters%20and%20play%20buttons%20warm%20cinematic%20lighting%20orange%20and%20amber%20accents%20clean%20dark%20theme%20professional%20design&width=1200&height=900&seq=hero-visual-01&orientation=landscape"
                  alt="桔子视频高清在线观看平台界面展示"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute -bottom-3 -left-3 bg-background-50 rounded-lg px-4 py-2 flex items-center gap-2 border border-background-200">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">
                  200+ 片源正在更新
                </span>
              </div>
              <div className="absolute -top-3 -right-3 bg-background-50 rounded-lg px-4 py-2 flex items-center gap-2 border border-background-200">
                <i className="ri-star-fill text-amber-400 text-sm"></i>
                <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">
                  9.8 用户评分
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}